<template>
  <div class="registration-field">
    <div class="form-group">
      <label
        class="form-label"
        :for="inputId"
      >
        {{ label }}
        {{ required ? '*' : '' }}
      </label>
      <slot />
      <brazil-error-label
        :field-name="name"
        :validator-field="validatorField"
        :validator-key="validatorKey"
      />
      <span
        v-if="$slots.note"
        class="post-note"
      >
        <slot name="note" />
      </span>
    </div>
  </div>
</template>
<script>
import BrazilErrorLabel from './BrazilErrorLabel.vue';

export default {
  components: {
    BrazilErrorLabel,
  },
  props: {
    inputId: {
      type:    String,
      default: '',
    },
    name: {
      type:    String,
      default: '',
    },
    label: {
      type:     String,
      required: true,
    },
    validatorField: {
      type:     Object,
      required: true,
    },
    validatorKey: {
      type:    String,
      default: null,
    },
  },
  computed: {
    required() {
      return Object.keys(this.validatorField).includes('required');
    },
  },
};
</script>
<style scoped>
.form-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #333333 !important;
}
.post-note {
  display: block;
  color: #333333;
}
</style>
